import { ActorRefFrom, createActor, waitFor } from 'xstate';

import { Logger } from '@eluve/logger';

import { sessionMachine } from './session.machine';
import { AccessTokenProvider, ISessionProvider } from './types';

const TOKEN_TIMEOUT_MS = 20_000;

export const sessionAccessTokenProvider: (args: {
  sessionProvider: ISessionProvider;
  logger?: Logger;
}) => {
  tokenProvider: AccessTokenProvider;
  sessionActor: ActorRefFrom<typeof sessionMachine>;
} = (args) => {
  const { sessionProvider, logger } = args;

  const sessionActor = createActor(sessionMachine, {
    input: {
      logger,
      sessionProvider,
    },
  });

  sessionActor.start();

  return {
    sessionActor,
    tokenProvider: async (options = { hardRefresh: false }) => {
      const { hardRefresh } = options;
      if (hardRefresh) {
        logger?.info('Hard refresh of access token requested');
        sessionActor.send({
          type: 'HARD_REFRESH_REQUESTED',
        });
      }

      const snapshot = sessionActor.getSnapshot();
      if (snapshot.matches('Idle')) {
        sessionActor.send({ type: 'ACQUIRE_TOKEN' });
      }

      const {
        context: { jwt, defaultRole: role },
      } = await waitFor(
        sessionActor,
        (state) => state.matches('TokenAvailable'),
        { timeout: TOKEN_TIMEOUT_MS },
      );

      return {
        jwt,
        role,
      };
    },
  };
};
